import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";

const defaults = {
  name: "",
  code: "",
  contactPerson: "",
  phone: "",
  status: "Active",
};

const CourierDialog = ({ open, onOpenChange, onSubmit, initial, title }) => {
  const [form, setForm] = useState(initial || defaults);

  const handleOpen = () => setForm(initial || defaults);

  const handleSubmit = () => {
    if (!form.name.trim() || !form.code.trim()) return;
    onSubmit(form);
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      slotProps={{ transition: { onEnter: handleOpen } }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Name *"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 100 } }}
          />
          <TextField
            label="Code *"
            value={form.code}
            onChange={(e) =>
              setForm({ ...form, code: e.target.value.toUpperCase() })
            }
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 10 } }}
          />
          <TextField
            label="Contact Person"
            value={form.contactPerson}
            onChange={(e) =>
              setForm({ ...form, contactPerson: e.target.value })
            }
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 100 } }}
          />
          <TextField
            label="Phone"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 20 } }}
          />
          <FormControl size="small" fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={form.status}
              label="Status"
              onChange={(e) =>
                setForm({ ...form, status: e.target.value })
              }
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!form.name.trim() || !form.code.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CourierDialog;
